import { lazy } from 'react';
import { SparkleFilled } from '@fluentui/react-icons';
import { FeatureDefinition } from '../../types/feature.types';

export const aiFeaturesDefinition: FeatureDefinition = {
  id: 'ai-features',
  name: 'AI Buddy',
  icon: SparkleFilled,
  component: lazy(() => import('./AiBuddy')),
  order: 10,
  enabled: true,
};
